import { Breakpoints, BreakpointWrapper, Container, ContainerGutter } from '@volkswagen-onehub/components-core';
import React from 'react';
import { Carline, SalesgroupWithCarline } from '../../../../../types/vehicle-types';
import { VehicleInfo } from '../ui/vehicle-info';
import { VehicleDesktopContainer } from '../ui/vehicle-selected-styles';
import { useVehicleImage } from './hooks/use-vehicle-image';
import { VehicleImageMobile, VehicleImage } from '../ui/vehicle-image';

interface Props {
	option: Carline | SalesgroupWithCarline;
	onSetGridView: () => void;
}

export const VehicleCardSelected = (props: Props) => {
	const { option, onSetGridView } = props;

	if (!option) return null;

	const carline = 'carline' in option ? option.carline : option;
	const { displayImage, etiquetas, setIsLateralImageLoaded } = useVehicleImage({
		option,
		loadLateralImage: true,
	});

	return (
		<>
			<BreakpointWrapper max={Breakpoints.b960}>
				<Container
					horizontalAlign={'center'}
					verticalAlign={'center'}
					wrap={'always'}
					data-testid={`vehicle-card-selected-${option.name}-mobile`}
					gutter={ContainerGutter.static200}
				>
					<VehicleImageMobile
						etiquetas={etiquetas}
						displayImage={displayImage({ lateral: true })}
						alt="Imagen lateral del vehículo"
						onError={() => setIsLateralImageLoaded(false)}
					/>
					<VehicleInfo title={option.title} isNew={Boolean(carline.nuevo)} hasCta onCtaClick={onSetGridView} />
				</Container>
			</BreakpointWrapper>

			<BreakpointWrapper min={Breakpoints.b960}>
				<VehicleDesktopContainer data-testid={`vehicle-card-selected-${option.name}-desktop`}>
					<VehicleInfo title={option.title} isNew={Boolean(carline.nuevo)} hasCta onCtaClick={onSetGridView} />
					<VehicleImage
						etiquetas={etiquetas}
						displayImage={displayImage({ lateral: true })}
						alt="Imagen lateral del vehículo"
						onError={() => setIsLateralImageLoaded(false)}
					/>
				</VehicleDesktopContainer>
			</BreakpointWrapper>
		</>
	);
};
